<template>
  <div id="app">
    <div style="display:flex">
      <select id="selectType" v-model="selType" style="margin-right:5px">
        <option v-for="(item, index) in types" :key="`type_${index}`">{{index}}</option>
      </select>
      <select id="selectFiles" v-model="selFile">
        <option v-for="(item, index) in files" :key="`file_${index}`">{{index}}</option>
      </select>
    </div>
    <div  v-if="tileSources.length > 1" style="display:flex">
      <button v-for="(item, index) in tileSources" 
      :key="`bt_${index}`" 
      :style="(!selected.includes(index)) ? `background-color: gray` : `background-color: rgb(${ colors[index].R }, ${ colors[index].G }, ${ colors[index].B });`"
      @click="selection(index)"
      >
      {{name(item)}}
    </button>
    </div>
    <div style="display:flex">
      <button @click="zoomIn"> + </button>
      <button @click="zoomOut"> - </button>
      <button @click="goHome"> RESET </button>
      <button @click="toggleFullPage"> FULL PAGE </button>
    </div>
    <open-seadragon-viewer 
    v-if="tileSources.length > 0"
    ref="viewer"
    :key="viewerKey" 
    :tileSources="tileSourcesComp" 
    :colors="colorsComp"
    :parameters="params"
    @params="updateParams"
    />
  </div>
</template>

<script>
import OpenSeadragonViewer from './components/OpenSeadragonViewer';
import forge from 'node-forge'

export default {
  name: 'App',
  components: {
    OpenSeadragonViewer
  },
  computed: {
    tileSourcesComp() {
     return this.tileSources.filter((_, index) => this.selected.includes(index));
},
    colorsComp() {
     return this.colors.filter((_, index) => this.selected.includes(index));
}
  },
  watch:{
    selFile() {
      this.tileSources = (this.selFile !== '') ? this.files[this.selFile].tileSources : []
      this.colors = this.files[this.selFile]?.colors ?? [];
      this.selected = this.files[this.selFile]?.selected ?? [];
      this.viewerKey += 1;
      this.params = null
    },
    selType() {
      this.files = this.sortObject(this.types[this.selType])
      this.selFile = Object.keys(this.types[this.selType])[0]
    }
  },
  data() {
    return {
      files:{},
      types: {},
      selFile: '',
      selType: '',
      selected: [],
      viewerKey: 0,
      tileSources: [],
      colors: [],
      params: null
    }
  },
  mounted() {
    fetch('files/files.json')
      .then(response => response.json())
      .then(data => {
       this.types = this.sortObject(data)
       this.selType = Object.keys(this.sortObject(data))[0]
      })
      .catch(error => {
        console.error('Error al cargar el archivo JSON:', error);
      });
  },
  methods: {
    name(name) {
      /* const parts = name.split('/')
      return parts.at(-1).replace('.dzi','') */
      name = this.decryptText(name)
      const regex = /_R\d{2}_/;
      const match = name.match(regex);
      if (match) {
        return match[0].replace(/_/g, '');
      }
      return "*ERROR*"
    },
    selection(sel) {
      if (this.selected.includes(sel)) {
          if (this.selected.length > 1) {
              this.selected = this.selected.filter(item => item !== sel);
          }
        } else {
          this.selected = [...this.selected, sel];
        }
        this.viewerKey += 1;
    },
    toggleFullPage() {
     const elem = document.getElementById("app");
      if (!document.fullscreenElement) {
        elem.requestFullscreen().catch(err => {
          alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
        });
      } else {
        document.exitFullscreen();
      }
    },
    zoomIn() {
      this.$refs.viewer.zoomIn();
    },
    zoomOut() {
      this.$refs.viewer.zoomOut();
    },
    goHome() {
      this.$refs.viewer.goHome();
    },
    updateParams(params) {
      this.params = params;
    },
    sortObject(obj) {
      const sortedKeys = Object.keys(obj).sort();
      const sortedObject = {};
      sortedKeys.forEach(key => {
        sortedObject[key] = obj[key];
      });
      return sortedObject;
  }
,    
    decryptText(encryptedText) {
      const privateKeyPem = `-----BEGIN PRIVATE KEY-----
MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQClPWxYuM0vbBQ0
SO4riSpyo+tL0pxIr9bFuFJQCZGyhLtOtu4yaZeB1iB9rT+URdEv6NxGGhmHmuWl
dLptRC4QL1S5K2cZ1fENMEb/6BUdmyPlullPyXO2+8rbDZoqFBLgfjNFR8tHqlWD
LGEhfCVeZWZvAkQEvsgDT3/f8dOwgeGDmQmpCSlW8rzYHfqfFYGoBSfBPLaLISYj
3h27+FLzJl5j0uPYPThceqY3xcmGfHWPmOBbXo8GNySEo3ValV1y7BjAlHuD8YKx
bWd9zV/HsXiiQlN2C6Nf4uU5QatTU7Em25nzqKKNVtt5DpfgmZCEldMT/Gkoer+s
2KVT8DODAgMBAAECggEAB5HPbwnvUbG1yzvRYqNmaKA/8kfs+OIf7CiaWShI13tj
V3g48hq1GvinTGGtmUaXuNt3xnHlamP+mSqp+k9vfMSKv0RfEaBcsTgyujkQ13SV
Ri27qMZCLzkTbsnxLK0voDEZl0irHtap2mZAR4KioAxmAOKDBPLaNB5l++kzNV+V
gBmkBaGVYsQSh6hSt4WJ5m54NkMQ7bz4I0wTzoghA2fFKCkwRsvuhCpcjvK6pd+V
vibagSp3YRaJWWXV4uQDpjjHI1m6qHH02yOPJl0U9Xtviw7fdLx6ZB8/S/FdBsro
zSp9etJqeKKrjMSBC4FKrA74S1KhUXmJnA2fRhzaoQKBgQDmD0xKRjxEuQI3HTra
xYEg1HhPNnkyxsLjydFsw4V6cSTgeNR8O5WRjYnrW/iF93BX0c8mhZSPkc3ujn0m
HNDskoy6+M2M/hItz9RKhpwCuUDoQT0+Y/+KuiviBD15aLtr1EQBuTXOqrdEAtvE
jlzaW4WiUKZscytxQkcSAWvMlwKBgQC33xfoVv2s8/6zCn6k7Cpoha0sugITyT8s
sHnp3C6rG6cYbvGO1mS5yXIz+251fqL7fDY1m5veGs8GI9kif28RX2hYih5+dowS
nkGQPQ6EcOcPFhRK183Kc2X/o1GTVqWlPFSrN4oP/xArnU31FmL+A2eD1EEWsn09
pLtIWFex9QKBgQDSK4GXjQh8A8QpU3Oz7qCjvFbYjrw0De53KKVAxnIHRJva0afU
gp6GJRatRA0LXdxs7ghfecMZUase118vVT3sEYmtOaSWvHkhDu8y0jxuJI1OYGMx
vyrxslhql1MNugcWYAlsxaWJUt4vrKjWrPPYq6mueh0/kAtM4a6JnXC8qwKBgHLC
C4LYIFV8p1+JUkeOml1H6TB8G2XL+eDjeAOMh5gFl0F5pMvYZV9LKjrlVyh/1CsP
eCn3J830f3c+knuke2alXFO+SI/3Xy8TlKn4YYIpkRxqVFnt3KPZaDSn8vb5YkMB
p3qBHGslbys5b3li8n/FEitGIyWOWvpJQRZDBOCtAoGADPL3ZGHKmSq0MgqxGvd9
qqDL6JefwnPsygU1MWnwKqdw9wtBjKcFOXB/OxH4PQ5UIMNbHzrF5mvw1G6MhOQw
iC6Sfrf+ukh2KWfZ+eykL0Ww+48MEiWuFZCZzbn483Vwyuy9XKxIJJ2LbNv4X4TH
qS+f1JrWLIC/YaWRu8xPx18=
-----END PRIVATE KEY-----`;

      try {
        const privateKey = forge.pki.privateKeyFromPem(privateKeyPem);
        const encryptedData = forge.util.decode64(encryptedText);
        const decrypted = privateKey.decrypt(encryptedData, 'RSA-OAEP', {
          md: forge.md.sha256.create()
        });
        return decrypted;
      } catch (error) {
        console.error('Error al descifrar el texto:', error);
        return [];
      }
    }
  },
}
</script>
<style>
body {
    background: black !important;
}
</style>